// EWM-242 / EWM-382 / EWM-469: maximum search query length. Bounded by
// commercetools, which caps search-expression string values at 256
// characters (https://docs.commercetools.com/api/search-query-language).
// The SSR product-list search wraps the query in a wildcard (`*<query>*`),
// adding 2 chars — so the query itself must be ≤ 254. A query between 255
// and the old 1000-char limit passed this gate but made commercetools
// reject the wildcard with a 400, which redirected the whole /search page
// to a 404 (EWM-469). Enforced client-side at every entry point that
// submits a product search so an overlong query surfaces a friendly inline
// error before navigating. The backend data source also now degrades a
// search 400 to an empty result, so a long query arriving directly via URL
// renders the no-results state instead of 404ing.
const CT_SEARCH_EXPRESSION_MAX = 256; // commercetools per-value limit
const WILDCARD_WRAPPER = 2; // the `*` either side of `*<query>*`
export const MAX_SEARCH_QUERY_LENGTH = CT_SEARCH_EXPRESSION_MAX - WILDCARD_WRAPPER;

// True when the (trimmed) query exceeds the limit — the trimmed length is
// what would actually be sent to the search backend.
export const isSearchQueryTooLong = (query: string): boolean => query.trim().length > MAX_SEARCH_QUERY_LENGTH;
